/**
 * Dog Store
 *
 * Zustand store for managing the currently selected dog
 * Persists across pages and sessions
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DogState {
  selectedDogId: string | null;
  setSelectedDogId: (dogId: string | null) => void;
}

export const useDogStore = create<DogState>()(
  persist(
    (set) => ({
      selectedDogId: null,
      setSelectedDogId: (dogId) => set({ selectedDogId: dogId }),
    }),
    {
      name: 'aiodog-selected-dog',
    }
  )
);
